import FormValidation from '@plone/volto/helpers/FormValidation/FormValidation';
import config from '@plone/volto/registry';

/**
 * Valida blocos do tipo columnsBlock e seus filhos recursivamente.
 * Retorna erros no formato { [blockId]: erros }.
 * @param {Object} params - { schema, formData, formatMessage }
 * @returns {Object} - Erros de validação por bloco
 */
export function validateColumnsBlock({ schema, formData, formatMessage }) {
  if (!formData || formData['@type'] !== 'columnsBlock') return {};
  const errors = {};
  validateColumnsBlockRecursive({
    block: formData,
    schema,
    formatMessage,
    errors,
    blockId: formData.id || formData['@id'] || 'columnsBlock',
  });
  return errors;
}

/**
 * Função recursiva para validar columnsBlock e blocos de conteúdo filhos.
 */

function validateColumnsBlockRecursive({
  block,
  schema,
  formatMessage,
  errors,
  blockId,
}) {
  if (!block) return;

  // Se for columnsBlock, valida apenas os filhos
  if (block['@type'] === 'columnsBlock') {
    const children = getBlockChildren(block);
    children.forEach(({ childBlock, childId }) => {
      if (!childBlock) return;
      // Se for container de blocos (coluna), desce mais um nível
      if (
        !childBlock['@type'] &&
        childBlock.blocks &&
        childBlock.blocks_layout
      ) {
        getBlockChildren(childBlock).forEach(
          ({ childBlock: grandChild, childId: grandChildId }) => {
            if (grandChild) {
              const grandChildSchema = getBlockSchema(grandChild, {
                formatMessage,
              });
              validateColumnsBlockRecursive({
                block: grandChild,
                schema: grandChildSchema,
                formatMessage,
                errors,
                blockId: grandChildId,
              });
            }
          },
        );
      } else {
        // Se já é um bloco de conteúdo ou outro columnsBlock
        const childSchema = getBlockSchema(childBlock, { formatMessage });
        validateColumnsBlockRecursive({
          block: childBlock,
          schema: childSchema,
          formatMessage,
          errors,
          blockId: childId,
        });
      }
    });
  } else if (block['@type']) {
    // Valida blocos de conteúdo (teaser, slate, etc)
    const validationErrors = FormValidation.validateFieldsPerFieldset({
      schema: schema || getBlockSchema(block, { formatMessage }),
      formData: block,
      formatMessage,
    });
    if (Object.keys(validationErrors).length > 0) {
      errors[blockId] = validationErrors;
    }
  }
}

/**
 * Retorna os filhos de um bloco (blocks + blocks_layout).
 */
function getBlockChildren(block) {
  const blocks = block.blocks || block.data?.blocks;
  const blocksLayout = block.blocks_layout || block.data?.blocks_layout;
  if (!blocks || !blocksLayout) return [];
  return blocksLayout.items.map((childId) => ({
    childBlock: blocks[childId],
    childId,
  }));
}

/**
 * Retrieves the schema for the block.
 * @param {Object} blockFormData - The block data to validate.
 * @param {Object} intl - The internationalization object.
 * @returns {Object} - The schema for the block.
 */

function getBlockSchema(blockFormData, intl) {
  const defaultSchema = {
    properties: {},
    fieldsets: [],
    required: [],
  };
  const blockType = blockFormData['@type'];
  const blockSchema =
    config.blocks.blocksConfig[blockType]?.blockSchema || defaultSchema;

  return typeof blockSchema === 'function'
    ? blockSchema({ intl, formData: blockFormData })
    : blockSchema;
}
